import React, { useEffect, useState } from "react";
import {
  HashRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./components/Home";
import AddBlog from "./components/AddBlog";
import EditBlog from "./components/EditBlog";
import BlogPage from "./components/BlogPage";
import Login from "./components/auth/Login";
import About from "./components/About";
import AddAds from "./components/AddAds";
import AdsPage from "./components/AdsPage";
import EditAds from "./components/EditAds";
import Cars from "./components/Cars";
import AddCar from "./components/AddCar";
import CarsPage from "./components/CarsPage";
import EditCar from "./components/EditCar";
import Blog from "./components/Blog";
import RealEstate from "./components/RealEstate";
import AddRealEstate from "./components/AddRealEstate";
import RealEstatePage from "./components/RealEstatePage";
import EditRealEstate from "./components/EditRealEstate";
import LebAds from "./components/LebAds";
import AbidjanAds from "./components/AbidjanAds";
import LebCars from "./components/LebCars";
import AbidjanCars from "./components/AbidjanCars";
import LebRealEstate from "./components/LebRealEstate";
import AbidjanRealEstate from "./components/AbidjanRealEstate";
import "./CSS/App.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import ScrollToTop from "./utils/scrollToTop";

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, user, fetchUserData } = useAuth();
  const location = useLocation();

  useEffect(() => {
    fetchUserData(); // Ensure the user data is refreshed on route change
  }, [location]); // Runs when the URL changes

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <AuthProvider>
        <HashRouter>
          <ScrollToTop />
          <div className="app-container">
            <Navbar />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/login" element={<Login />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:id" element={<BlogPage />} />
                <Route path="/lebanon-ads" element={<LebAds />} />
                <Route path="/abidjan-ads" element={<AbidjanAds />} />
                <Route path="/lebanon-cars" element={<LebCars />} />
                <Route path="/abidjan-cars" element={<AbidjanCars />} />
                <Route path="/lebanon-realestate" element={<LebRealEstate />} />
                <Route
                  path="/abidjan-realestate"
                  element={<AbidjanRealEstate />}
                />
                <Route path="/car/:id" element={<CarsPage />} />
                <Route path="/ads/:id" element={<AdsPage />} />
                <Route path="/realestate/:id" element={<RealEstatePage />} />

                <Route
                  path="/add-blog"
                  element={
                    <PrivateRoute>
                      <AddBlog />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/edit-blog/:id"
                  element={
                    <PrivateRoute>
                      <EditBlog />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/add-ads"
                  element={
                    <PrivateRoute>
                      <AddAds />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/edit-ads/:id"
                  element={
                    <PrivateRoute>
                      <EditAds />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/add-car"
                  element={
                    <PrivateRoute>
                      <AddCar />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/edit-car/:id"
                  element={
                    <PrivateRoute>
                      <EditCar />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/add-realestate"
                  element={
                    <PrivateRoute>
                      <AddRealEstate />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/edit-realestate/:id"
                  element={
                    <PrivateRoute>
                      <EditRealEstate />
                    </PrivateRoute>
                  }
                />
              </Routes>
            </main>
            <Footer />
          </div>
        </HashRouter>
      </AuthProvider>
    </HelmetProvider>
  );
};

export default App;
